import Dashboard from "../Pages/Dashboard/Dashboard";
import PaymentById from "../Pages/PaymentById";
import PaymentManagement from "../Pages/PaymentManagement";
import ProductById from "../Pages/ProductById";
import ProductManagement from "../Pages/ProductManagement";
import ServiceById from "../Pages/ServiceById";
import ServiceManagement from "../Pages/ServiceManagement";
import UserById from "../Pages/UserById";
import UserManagement from "../Pages/UserManagement/UserManagement";
import {
  DashboardRoute,
  PaymentManagementRoute,
  ProductRequestManagementRoute,
  ServiceRequestManagementRoute,
  UserManagementRoute,
} from "../utils/Constant";

const routes = [
  // dashboard
  {
    path: `/${DashboardRoute}`,
    Component: <Dashboard />,
  },

  // User management
  {
    path: `/${UserManagementRoute}`,
    Component: <UserManagement />,
  },

  {
    path: `/${UserManagementRoute}/:userId`,
    Component: <UserById />,
  },

  // Service Management
  {
    path: `/${ServiceRequestManagementRoute}`,
    Component: <ServiceManagement />,
  },
  {
    path: `/${ServiceRequestManagementRoute}/:serviceId`,
    Component: <ServiceById />,
  },

  // Product Management
  {
    path: `/${ProductRequestManagementRoute}`,
    Component: <ProductManagement />,
  },
  {
    path: `/${ProductRequestManagementRoute}/:productId`,
    Component: <ProductById />,
  },

  // Payment Management
  {
    path: `/${PaymentManagementRoute}`,
    Component: <PaymentManagement />,
  },
  {
    path: `/${PaymentManagementRoute}/:paymentId`,
    Component: <PaymentById />,
  },
];

export default routes;
